import OrderHandler from "../OrderHandler";
import { getAllItems } from "../../../HTTPRequests/OrderRequests";
import ItemCategory from "../../../Models/ItemCategory";
import openErrorModal from "../../../Error/ErrorModal";
import ItemTile from "./ItemTile";
import Loader from "../../../DomUtilities/Loader";
import FastTrack from "./FastTrack";

export default class ChooseItem {
	chooseItem: HTMLDivElement;
	stepsWrapper: HTMLDivElement;
	items: ItemCategory[];

	constructor() {
		this.stepsWrapper = document.querySelector('.create-order > div');
		Loader.show();
		this.fetchAllItems();
	}

	private fetchAllItems() {
		getAllItems()
			.then((allItems: Array<ItemCategory>) => {
				this.setItems(allItems);
				this.fetchItemTiles();
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			});
	}

	private setItems(allItems: ItemCategory[]) {
		OrderHandler.items = allItems;
		const fastTrackItems = allItems.filter(i => i.isFastTrack);
		this.items = allItems.filter(i => !i.isFastTrack);
		new FastTrack(fastTrackItems);
		Loader.hide();
	}

	public fetchItemTiles() {
		this.chooseItem = document.createElement('div');
		this.chooseItem.classList.add("choose-item");
		const seprator = document.createElement('hr');
		this.chooseItem.appendChild(seprator);
		const itemsWrapper = document.createElement('div');
		this.chooseItem.appendChild(itemsWrapper);

		if (this.items.length > 0) {
			for (let i = 0; i < this.items.length; i++) {
				const itemTile = new ItemTile(this.items[i]);
				itemsWrapper.appendChild(itemTile.itemTile);
			}
		} else {
			const emptyMessage = document.createElement('h5');
			emptyMessage.style.margin = "auto";
			emptyMessage.innerText = this.stepsWrapper.dataset.emptyItems;
			itemsWrapper.appendChild(emptyMessage);
		}

		this.stepsWrapper.appendChild(this.chooseItem);
	}

	public removeChooseItem() {
		this.chooseItem.remove();
	}
}
